var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { endOfDay, format, getYear, isMatch, isValid, parse, parseISO, startOfDay } from 'date-fns';
import { enUS } from 'date-fns/locale';
import React from 'react';
var FORMAT_PERIOD_HOUR_LABEL = /,\s*\d{1,2}:\d{2}/;
export function normalizeTooltipLabelWhitespace(s) {
    return s.replace(/\u202f|\u00a0/g, ' ');
}
function isClockHourAmPmLabel(trimmed) {
    if (isMatch(trimmed, 'h a', { locale: enUS }))
        return true;
    return /^\d{1,2}\s+[AP]M$/i.test(trimmed);
}
function tooltipDateHeadingSpan(text) {
    return _jsx("span", __assign({ className: "font-semibold text-gray-900" }, { children: text }));
}
function isMonthYearPeriodLabel(trimmed) {
    if (!/^[A-Za-z]{3,9}\s+\d{4}$/.test(trimmed))
        return false;
    return isMatch(trimmed, 'MMM yyyy', { locale: enUS });
}
export function isPassThroughPeriodHeading(trimmed) {
    if (FORMAT_PERIOD_HOUR_LABEL.test(trimmed))
        return true;
    if (isClockHourAmPmLabel(trimmed))
        return true;
    if (trimmed.includes(' - '))
        return true;
    if (isMonthYearPeriodLabel(trimmed))
        return true;
    return false;
}
function parseFilterCalendarDay(dateStr) {
    var day = dateStr.trim().slice(0, 10);
    if (!isMatch(day, 'yyyy-MM-dd', { locale: enUS }))
        return null;
    var d = parse(day, 'yyyy-MM-dd', new Date(), { locale: enUS });
    return isValid(d) ? startOfDay(d) : null;
}
export function parseIsoCalendarDayOrDateTime(trimmed) {
    var plainDay = isMatch(trimmed, 'yyyy-MM-dd', { locale: enUS });
    var dayTime = trimmed.length >= 11 &&
        trimmed[4] === '-' &&
        trimmed[7] === '-' &&
        trimmed[10] === 'T';
    if (plainDay) {
        var d_1 = parse(trimmed.slice(0, 10), 'yyyy-MM-dd', new Date(), {
            locale: enUS
        });
        return isValid(d_1) ? d_1 : null;
    }
    if (!dayTime)
        return null;
    var d = parseISO(trimmed);
    return isValid(d) ? d : null;
}
export function parseMmmDInFilterRange(trimmed, dateFromStr, dateToStr) {
    var rangeStart = parseFilterCalendarDay(dateFromStr);
    var rangeEndDay = parseFilterCalendarDay(dateToStr);
    if (!rangeStart || !rangeEndDay)
        return null;
    var rangeEnd = endOfDay(rangeEndDay);
    var yMin = getYear(rangeStart);
    var yMax = getYear(rangeEnd);
    for (var y = yMin; y <= yMax + 1; y++) {
        var d = parse("".concat(trimmed, " ").concat(y), 'MMM d yyyy', rangeStart, {
            locale: enUS
        });
        if (!isValid(d))
            continue;
        if (format(d, 'MMM d', { locale: enUS }) !== trimmed)
            continue;
        if (d >= rangeStart && d <= rangeEnd)
            return d;
    }
    return null;
}
export function renderTooltipDateHeading(name, options) {
    var trimmed = normalizeTooltipLabelWhitespace(name).trim();
    if (!trimmed)
        return trimmed;
    if (isPassThroughPeriodHeading(trimmed)) {
        return tooltipDateHeadingSpan(trimmed);
    }
    var date = null;
    var fromIso = parseIsoCalendarDayOrDateTime(trimmed);
    if (fromIso) {
        date = fromIso;
    }
    else if ((options === null || options === void 0 ? void 0 : options.referenceDateFrom) && (options === null || options === void 0 ? void 0 : options.referenceDateTo)) {
        date = parseMmmDInFilterRange(trimmed, options.referenceDateFrom, options.referenceDateTo);
    }
    if (date) {
        return (_jsx("span", __assign({ className: "font-semibold text-gray-900" }, { children: format(date, 'EEE - MMM d - yyyy', { locale: enUS }) })));
    }
    return _jsx("span", __assign({ className: "font-semibold text-gray-900" }, { children: trimmed }));
}
export function formatIsoDateForPlainTooltip(isoDateStr) {
    var trimmed = normalizeTooltipLabelWhitespace(isoDateStr).trim();
    if (!trimmed)
        return trimmed;
    var d = parseIsoCalendarDayOrDateTime(trimmed);
    if (!d)
        return trimmed;
    return format(d, 'EEE - MMM d - yyyy', { locale: enUS });
}
